export * from './landing.controller';
import landing from './landing.html';

export { landing }
